"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presets = void 0;
var react_spring_1 = require("react-spring");
Object.defineProperty(exports, "presets", { enumerable: true, get: function () { return react_spring_1.config; } });
var TextTransition_1 = require("./components/TextTransition");
exports.default = TextTransition_1.default;
//# sourceMappingURL=index.js.map